import RecyclingList from './RecyclingList';

export default RecyclingList;
